module.exports = __webpack_public_path__ + "static/media/bg.6695af99.svg";